import ReactGA from 'react-ga'

import { GA_TRACKING_ID, IS_DEV, IS_PROD } from '../environment'
import { AssessmentState, GoalState, GoalType, ReviewType } from './front-face/models'

const trackers: ReactGA.Tracker[] = []
const sendToTrackers: string[] = []

export const GAinit = () => {
  if (IS_DEV) {
    trackers.push({
      trackingId: 'UA-131252814-1', // @RK tracker
      gaOptions: {
        name: 'RK',
      },
    })

    sendToTrackers.push('RK')
  }

  if (IS_PROD) {
    trackers.push({
      trackingId: GA_TRACKING_ID,
    })
  }

  ReactGA.initialize(trackers)
  ReactGA.pageview(window.location.pathname + window.location.search, sendToTrackers)
}

const category = {
  goal: 'Goal',
  feedback: 'Feedback',
  review: 'Review',
  assessment: 'Assessment',
}

export const GACreateGoal = (type: GoalType) =>
  ReactGA.event(
    {
      category: category.goal,
      action: 'Create goal',
      label: GoalType[type],
    },
    sendToTrackers
  )

export const GAGoalStateChange = (type: GoalType, state: GoalState) =>
  ReactGA.event(
    {
      category: category.goal,
      action: 'Goal change state',
      label: GoalType[type],
      value: state,
    },
    sendToTrackers
  )

export const GACreateFeedback = (isRequested: boolean) =>
  ReactGA.event(
    {
      category: category.feedback,
      action: 'Create feedback',
      label: `requested: ${isRequested}`,
    },
    sendToTrackers
  )

export const GACreateReview = (type: ReviewType) =>
  ReactGA.event(
    {
      category: category.review,
      action: 'Create review',
      label: ReviewType[type],
    },
    sendToTrackers
  )

export const GAAssessmentChangeState = (reviewType: ReviewType, state: AssessmentState) =>
  ReactGA.event(
    {
      category: category.assessment,
      action: 'Assessment change state',
      label: ReviewType[reviewType],
      value: state,
    },
    sendToTrackers
  )



// WEBPACK FOOTER //
// ./src/app/analytics.ts